// @flow
/* eslint-disable import/prefer-default-export */
import useMediaQuery from '@material-ui/core/useMediaQuery';

import theme from '@theme';

const { breakpoints } = theme;

export const useBreakpoint = (gte: string, lt: ?string) => {
  if (breakpoints[gte] === undefined || (lt && breakpoints[lt] === undefined)) {
    throw new Error(
      `Provided breakpoint does not exist. Use one of: ${Object.keys(breakpoints).join(' | ')}`
    );
  }

  const query = !lt
    ? `(min-width:${breakpoints[gte]}px)`
    : `(min-width:${breakpoints[gte]}px) and (max-width:${breakpoints[lt]}px)`;

  return useMediaQuery(query);
};
